import { useState } from "react";
import apiClient from "../apiClient";

export default function IndexNowSubmit() {
    const [urls, setUrls] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);

    const validateUrls = (urlString) => {
        const urlArray = urlString.split(",").map((u) => u.trim());

        const invalidUrls = urlArray.filter((url) => {
            try {
                new URL(url);
                return false;
            } catch {
                return true;
            }
        });

        return {
            valid: invalidUrls.length === 0,
            invalidUrls,
            urlArray,
        };
    };

    const handleSubmit = async () => {
        setError("");
        setSuccess("");

        if (!urls) {
            setError("Please enter at least one URL.");
            return;
        }

        const result = validateUrls(urls);

        if (!result.valid) {
            setError(`Invalid URL(s): ${result.invalidUrls.join(", ")}`);
            return;
        }

        try {
            setLoading(true);

            await apiClient.post("/blog/url/index-now", { urls: result.urlArray });

            setSuccess("URLs successfully submitted to IndexNow.");
            setUrls("");

        } catch (err) {
            setError("Server error occurred.");
        }

        setLoading(false);
    };

    return (
        <div
            style={{
                margin: "40px auto",
                padding: "20px",
                border: "1px solid #ddd",
                borderRadius: "8px",
                fontFamily: "Arial",
            }}
        >
            <h2 style={{ marginBottom: "10px" }}>Submit URLs to IndexNow</h2>

            <p style={{ fontSize: "14px", color: "#666" }}>
                Enter multiple URLs separated by commas.
            </p>

            <textarea
                value={urls}
                onChange={(e) => setUrls(e.target.value)}
                placeholder="https://example.com/page1, https://example.com/page2"
                style={{
                    width: "100%",
                    height: "220px",
                    padding: "10px",
                    marginTop: "10px",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    fontSize: "14px",
                }}
            />

            <button
                onClick={handleSubmit}
                disabled={loading}
                style={{
                    marginTop: "15px",
                    padding: "10px 20px",
                    backgroundColor: "#0070f3",
                    color: "#fff",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                }}
            >
                {loading ? "Submitting..." : "Submit URLs"}
            </button>

            {error && (
                <div
                    style={{
                        marginTop: "15px",
                        padding: "10px",
                        backgroundColor: "#ffe6e6",
                        color: "#d8000c",
                        borderRadius: "4px",
                    }}
                >
                    {error}
                </div>
            )}

            {success && (
                <div
                    style={{
                        marginTop: "15px",
                        padding: "10px",
                        backgroundColor: "#e6ffed",
                        color: "#2e7d32",
                        borderRadius: "4px",
                    }}
                >
                    {success}
                </div>
            )}
        </div>
    );
}